import React from "react";
import { Button } from "antd";
import successImage from "@/assets/images/success-ok.png";
import failedImage from "@/assets/images/audio-failed.png";
import { useTranslation } from "react-i18next";

import "@/assets/videoMute.less";

const VideoMuteFinishRender = ({ submitStatus, handleDownload, handleTryAgain, handleGoToEdit }) => {
  const { t } = useTranslation(["videoMute", "common"]);

  return (
    <div className="work-cont-finish">
      {submitStatus === "success" ? (
        <div className="success">
          <h2>{t("common:Generate Files Successfully!")}</h2>
          <img alt="success" src={successImage} />
          <div className="btn-group">
            <Button type="primary" size="large" onClick={handleDownload}>
              {t("common:Download")}
            </Button>
            <Button type="primary" size="large" ghost onClick={handleGoToEdit}>
              {t("common:Go Edit")}
            </Button>
          </div>
          <span
            className="new-link"
            onClick={() => {
              window.open(window.location.href);
            }}
          >
            {t("Mute New")}
          </span>
        </div>
      ) : (
        <div className="failed">
          <h2>{t("Mute Failed")}</h2>
          <img alt="success" src={failedImage} />
          <div className="btn-group">
            <Button type="primary" size="large" onClick={handleTryAgain}>
              {t("common:Try Again")}
            </Button>
            <Button
              type="primary"
              size="large"
              ghost
              onClick={() => {
                window.open(window.location.href);
              }}
            >
              {t("Mute New")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoMuteFinishRender;
